import { Snackbar } from "@material-ui/core";
import MuiAlert from "@material-ui/lab/Alert";
import "./Alert.scss";
// import Redux
import { useSelector, useDispatch } from "react-redux";
import { RootState } from "../store/reducers";
import { bindActionCreators } from "redux";
import { actionCreators } from "../store";
import AlertTitle from '@mui/material/AlertTitle';



const CustomAlert = (props: any) => {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
};

const Alert = () => {
  const dispatch = useDispatch();
  const { alert, langValue } = useSelector((state: RootState) => state.waiter);
  const { langValueState, freezScreenState, alertHideState } =
    bindActionCreators(actionCreators, dispatch);
  const handleClose = () => {
    alertHideState({
      show: false,
      type: alert.type,
      message: alert.message,
    });
  };
  setTimeout(() => {
    if (alert.show) {
      handleClose();
    }
  }, 3000);
  return (
    <Snackbar
      anchorOrigin={langValue === "ar" ? { vertical: "bottom", horizontal: "left" } : { vertical: "bottom", horizontal: "right" }}
      open={alert.show}
      onClose={handleClose}
      style={langValue === "ar" ? { direction: "ltr" } : { direction: "ltr" }}
      id="Alert"
      

      
 
    >
      <CustomAlert
        onClose={handleClose}
        severity={alert.type ? alert.type : ""}
      

      >
         {alert.type == "success" &&   <AlertTitle>This is an success message!</AlertTitle> }
          {alert.type == "warning" &&<AlertTitle>This is a warning message!</AlertTitle> }
          {alert.type == "informational" && <AlertTitle>This is an informational message!</AlertTitle> }
          {alert.type == "error" && <AlertTitle>This is an error message!</AlertTitle> }

        <strong className="Message">{alert.message}</strong>
      </CustomAlert>
    </Snackbar>
  );
};

export default Alert;
